import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from '..';

enum HttpContextRoutes {
  GetDprReportDownload,
}

export const HttpReportContext = createRouteContextObject(
  HttpContextBase.Report,
  HttpContextRoutes
);
